import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Check from './__partials/check';
import { marginClassNamePropType } from '../__utils/spacingClassNamePropType';

import './style.scss';

const handleMouseEnter = e => {
  if (e.currentTarget.classList.contains('uni-selectmark--is-selected')) {
    e.currentTarget.classList.add('uni-selectmark--has-mouse-event');
  }
};

const SelectMark = ({ size, selectedState, isHovered, qaId, onClick, className }) => {
  const selectmarkClasses = classNames('uni-selectmark', {
    [`uni-selectmark--${size}`]: size,
    'uni-selectmark--is-hovered': isHovered,
    'uni-selectmark--is-selected': selectedState === 'selected',
    'uni-selectmark--is-unselected': selectedState === 'unselected',
    [className]: className,
  });

  const handleKeyDown = e => {
    // We only want to run the onClick when the spacebar is hit.
    if (e.keyCode === 32) {
      onClick();
    }
  };

  return (
    <div
      className={selectmarkClasses}
      role="checkbox"
      tabIndex="0"
      aria-checked={selectedState === 'selected'}
      data-qa-id={qaId}
      onMouseEnter={handleMouseEnter}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <div className="uni-selectmark__circle" />
      <div className="uni-selectmark__svg-container">
        <Check svgClass="uni-selectmark__svg--check" pathClass="uni-selectmark__svg-path--check" />
      </div>
    </div>
  );
};

SelectMark.propTypes = {
  size: PropTypes.PropTypes.oneOf(['small', 'medium', 'large']),
  selectedState: PropTypes.oneOf(['default', 'selected', 'unselected']),
  isHovered: PropTypes.bool,
  qaId: PropTypes.string,
  onClick: PropTypes.func,
  className: marginClassNamePropType,
};

SelectMark.defaultProps = {
  size: 'medium',
  selectedState: 'default',
  className: '',
};

export default SelectMark;



// WEBPACK FOOTER //
// ./src/select-mark/index.jsx